import { StyleSheet } from 'react-native';
import { appTheme } from '@/config/colors';

import colors from '@/config/colors';

export const styles = StyleSheet.create({
  header: {
    backgroundColor: appTheme.primary,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    position: 'relative',
    overflow: 'visible',
  },
  stickyNavbar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
  },
  headerBodyWrapper: {
    zIndex: 10000,
    elevation: 20,
    position: 'absolute',
    left: 55,
    top: 65,
  },
  headerCollapseButton: {
    borderRadius: 180,
    backgroundColor: '#FEFEFE',
    padding: 6,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 6,
    borderColor: colors.newUI.therapist.primaryBlue10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 4,
  },
  leftSideWrapper: {
    paddingLeft: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconContainer: {
    paddingLeft: 8,
  },
  navItemText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '500',
  },
  centeredTitleContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: -1,
  },
  titleText: {
    color: '#fff',
    fontSize: 18,
    fontWeight: '600',
  },
});
